export function buildScheduleDialogState(schedule, sortedSchedules = []) {
  if (!schedule) {
    return {
      open: true,
      scheduleId: null,
      label: "",
      scheduleType: "",
      minDate: "",
      maxDate: "",
      selectedDate: "",
    };
  }

  const list = sortedSchedules || [];
  const sameExecution = list.filter((x) => x.execution_id === schedule.execution_id);
  const idx = sameExecution.findIndex((x) => x.id === schedule.id);
  const prev = idx > 0 ? sameExecution[idx - 1] : null;
  const prevDate = prev ? (prev.scheduled_date || prev.optimal_date) : "";
  const scheduleOrder = schedule.schedule ?? schedule.order;
  const isStaticNonFirst =
    String(schedule.type || schedule.schedule_type || "").toLowerCase() === "static" &&
    Number(scheduleOrder) !== 1;

  return {
    open: true,
    scheduleId: schedule.id,
    label: `Schedule ${scheduleOrder}`,
    scheduleType: String(schedule.type || schedule.schedule_type || "").toUpperCase(),
    minDate: isStaticNonFirst ? prevDate || "" : (schedule.window_open ?? prevDate) || "",
    maxDate: isStaticNonFirst ? "" : (schedule.window_close || ""),
    selectedDate: schedule.scheduled_date || schedule.actual_date || schedule.optimal_date || "",
  };
}

export const emptyScheduleDialogState = {
  open: false,
  scheduleId: null,
  label: "",
  scheduleType: "",
  minDate: "",
  maxDate: "",
  selectedDate: "",
};
